import { MouseEventHandler } from "react";
import { ButtonParts } from "~/components/atoms/ButtonParts";

type Props = {
  onClick: MouseEventHandler<HTMLDivElement>
  open: boolean
}

export function ButtonShowAll({ onClick, open }: Props) {
  return (
    <div className="accordion-btn" onClick={onClick}><ButtonParts className="btn btn-light"><span
      className={open ? "down-arrow" : "top-arrow"} /><span>{open ? "元に戻す" : "商品を全て表示する"}</span></ButtonParts>
    </div>
  )
}
